import * as t from 'io-ts';

import {makeApiType} from '../../models/api/apiTypes';

export const ApiTagsBatchData = makeApiType(
  'tagsBatchData',
  t.type({
    requesterId: t.number,
    tagIds: t.readonlyArray(t.number),
  }),
  (data) => ({
    requesterId: data.requester_id,
    tagIds: data.tag_ids || [],
  }),
);
